/**
 * Enova Event Section
 * - Countdown timer
 * - Auto show/hide based on start/end dates
 * - Swiper carousel init
 */

(function() {
  const sections = document.querySelectorAll('.enova-event');

  sections.forEach(function(section) {
    const sectionId = section.dataset.sectionId;
    const startDate = section.dataset.startDate;
    const endDate = section.dataset.endDate;
    const countdownDate = section.dataset.countdownDate;

    /* ==============================
       Visibility: Start/End dates
       ============================== */
    function checkVisibility() {
      const now = new Date();

      if (startDate) {
        const start = new Date(startDate);
        if (now < start) {
          section.setAttribute('data-visible', 'false');
          return false;
        }
      }

      if (endDate) {
        const end = new Date(endDate);
        if (now > end) {
          section.setAttribute('data-visible', 'false');
          return false;
        }
      }

      section.setAttribute('data-visible', 'true');
      return true;
    }

    /* ==============================
       Countdown Timer
       ============================== */
    function initCountdown() {
      if (!countdownDate) return;

      var target = new Date(countdownDate).getTime();
      var daysEl = section.querySelector('[data-countdown-days]');
      var hoursEl = section.querySelector('[data-countdown-hours]');
      var minutesEl = section.querySelector('[data-countdown-minutes]');
      var secondsEl = section.querySelector('[data-countdown-seconds]');
      var countdownEl = section.querySelector('.enova-event__countdown');

      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

      function update() {
        var now = new Date().getTime();
        var distance = target - now;

        if (distance <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          if (countdownEl) countdownEl.classList.add('enova-event__countdown--ended');
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.textContent = String(days).padStart(2, '0');
        hoursEl.textContent = String(hours).padStart(2, '0');
        minutesEl.textContent = String(minutes).padStart(2, '0');
        secondsEl.textContent = String(seconds).padStart(2, '0');
      }

      update();
      setInterval(update, 1000);
    }

    /* ==============================
       Swiper Carousel
       ============================== */
    function initSwiper() {
      var swiperEl = section.querySelector('.enova-event__swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      var colsDesktop = parseInt(swiperEl.dataset.columnsDesktop) || 4;
      var colsTablet = parseInt(swiperEl.dataset.columnsTablet) || 3;
      var colsMobile = parseFloat(swiperEl.dataset.columnsMobile) || 2;
      var spaceBetween = parseInt(swiperEl.dataset.spaceBetween) || 16;
      var autoplay = swiperEl.dataset.autoplay === 'true';
      var autoplaySpeed = parseInt(swiperEl.dataset.autoplaySpeed) || 5000;
      var loop = swiperEl.dataset.loop === 'true';

      var config = {
        slidesPerView: colsMobile,
        spaceBetween: spaceBetween,
        watchOverflow: true,
        breakpoints: {
          750: {
            slidesPerView: colsTablet
          },
          990: {
            slidesPerView: colsDesktop
          }
        }
      };

      var prevBtn = section.querySelector('.enova-event__arrow--prev');
      var nextBtn = section.querySelector('.enova-event__arrow--next');
      if (prevBtn && nextBtn) {
        config.navigation = {
          prevEl: prevBtn,
          nextEl: nextBtn
        };
      }

      var pagination = swiperEl.querySelector('.swiper-pagination');
      if (pagination) {
        config.pagination = {
          el: pagination,
          clickable: true
        };
      }

      if (autoplay) {
        config.autoplay = {
          delay: autoplaySpeed,
          disableOnInteraction: false
        };
      }

      if (loop) {
        config.loop = true;
      }

      new Swiper(swiperEl, config);
    }

    /* ==============================
       Init
       ============================== */
    var isVisible = checkVisibility();
    setInterval(checkVisibility, 60000);

    if (isVisible) {
      initCountdown();
      initSwiper();
    }
  });
})();
